import { useMainStyles } from "../classes/main";
import { TextField } from "@mui/material";

const EditableNumeric = (props) => {
    const classes = useMainStyles();
  
    return (
      <TextField
        autoFocus={true}
        InputProps={{
          // disableUnderline: true,
          classes: {
            root: classes.standCardInput,
            disabled: classes.standCardInputDisabled,
          },
        }}
        id={props.id}
        type="number"
        disabled={props.disabled}
        value={props.value}
        onChange={props.onChange}
      />
    );
  };
  
  export default EditableNumeric;